import type { AssistantMessage } from '@triedge/ai-assistant-ui';
import type { AdmissionsAIContextualAction, AdmissionsAssistantMessageMetadata, AdmissionsCitation } from './types';
import type { AssistantTaskListItem } from './assistantTaskLaneState';

const toMetadata = (
  message: AssistantMessage<AdmissionsCitation, AdmissionsAIContextualAction>,
): AdmissionsAssistantMessageMetadata | null => {
  const metadata = message.metadata;
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) {
    return null;
  }
  return metadata as AdmissionsAssistantMessageMetadata;
};

export const resolveConversationThreadIdForTask = (
  messages: readonly AssistantMessage<AdmissionsCitation, AdmissionsAIContextualAction>[],
  task: Pick<AssistantTaskListItem, 'id' | 'runId' | 'workflowKey' | 'title'>,
): string | null => {
  const normalizedTaskRunId = String(task.runId ?? '').trim();
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (!message || message.role !== 'assistant') {
      continue;
    }
    const taskThread = toMetadata(message)?.taskThread;
    const threadId = String(taskThread?.threadId ?? '').trim();
    if (!threadId) {
      continue;
    }
    const workItemId = String(taskThread?.workItemId ?? '').trim();
    if (workItemId && workItemId === task.id) {
      return threadId;
    }
    const runId = String(taskThread?.runId ?? '').trim();
    if (runId && task.runId && runId === task.runId) {
      return threadId;
    }
    if (normalizedTaskRunId) {
      continue;
    }
    const workflowKey = String(taskThread?.workflowKey ?? '').trim();
    const title = String(taskThread?.title ?? '').trim();
    if (
      workflowKey
      && task.workflowKey
      && workflowKey === task.workflowKey
      && title
      && title === task.title
    ) {
      return threadId;
    }
  }
  return null;
};
